var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"p-content-plan-manual-trend-keywords"},_vm._l((_vm.keywordItems),function(keyword){return _c('ListItemContentManualKeyword',{key:keyword.word,attrs:{"keyword":keyword,"max":_vm.max}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }